

import { usePathname } from 'next/navigation'
import Image from "next/image";
import Link from "next/link";
import useCommonStore from '@/store/commonStore';
import NewsLetter from './newsLetter';




export default function Footer() {
  const { translations } = useCommonStore()



  const features = [
    {
      icon: process.env.NEXT_PUBLIC_ICON_URL + "341172c6-6ee9-4291-8550-50dea2d3c372.svg",
      title: `${translations["exc_off"] || "Exclusive offers"}`,
    },
    {
      icon: process.env.NEXT_PUBLIC_ICON_URL + "dbace8ee-53c6-4f7c-bf2c-a0a5899d8a98.svg",
      title: `${translations["genuine_prod"] || "Genuine product"}`,
    },
    {
      icon: process.env.NEXT_PUBLIC_ICON_URL + "43163db6-dea9-4ce6-aeb5-f7196b449e88.svg",
      title: `${translations["safe_nd_sec_ship"] || "Safe and secure Shipping"}`,
    },
    {
      icon: process.env.NEXT_PUBLIC_ICON_URL + "9d3992da-c5a7-4a24-82a0-86ee14bb2286.svg",
      title: `${translations["free_ship"] || "Free shipping\nT&C"}`,
    },
  ];
  const customerCareLinks = [
    { label: `${translations["shipping"] || "Shipping"}`, href: "/shipping-policy" },
    { label: `${translations["rtn_exchg"] || "Return & Exchanges"}`, href: "/return-exchange" },
    { label: `${translations["abt_us"] || "About us"}`, href: "/about-us" },
    { label: `${translations["prvcy_polcy"] || 'Privacy policy'}`, href: "/privacy-policy" },
    { label: `${translations["trm_nd_cdtn"] || "Terms and conditions"}`, href: "/terms-conditions" },
  ];
  const pathname = usePathname()

  // Hide footer on login route
  if (pathname === '/login') return null

  return (
    <footer className=" hidden md:block">
      {/* Feature icons row */}
      <div className='bg-[#FFFCF3] py-10'>
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
          {features.map((f, i) => (
            <div key={i} className="flex flex-col items-center text-center">
              <div className="mb-2 h-[60px] flex justify-center">
                <Image src={f.icon} alt={f.title} width={50} height={50} className='' />
              </div>
              <div className="font-semibold text-lg text-black whitespace-pre-line">{f.title}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-white mt-0 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-24">
          {/* Customer care */}
          <div>
            <div className="font-bold text-lg mb-4">{translations["cust_care"] || "Customer care"}</div>
            <ul className="space-y-2">
              {customerCareLinks.map((link, i) => (
                <li key={i}>
                  <Link href={link.href} className="text-gray-700 hover:underline text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <div className="font-bold mb-2">{translations["fllw_us"] || "Follow us"}</div>
              <div className="flex space-x-3">
                {/* <a href="https://www.instagram.com/curlifiedofficial/" target='_blank' aria-label="Instagram">
                  <Image src="https://img.curlified.com/icons/instagram.svg" alt="Instagram" width={28} height={28} />
                </a> */}
                <a href="https://www.facebook.com/people/Curlified/100093415820448/" target='_blank' aria-label="Facebook">
                  <Image src="https://curlified.com/assets/facebook.fede815d.svg" alt="Facebook" width={28} height={28} />
                </a>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <div>
              <div className="font-bold text-lg mb-4">
                {translations["news_lettr"] || "News letters"}
              </div>


              <NewsLetter translations={translations} />
            </div>
            <div className="font-bold text-lg mb-4">
              <a href="https://blog.curlified.com/" target='_blank'>{translations["blogs"] || "Blogs"}</a>
            </div>
            <div>
              <div className="font-bold text-lg mb-2">{translations["accp_pymnt"] || "Accepted Payments"}</div>
              <div className="flex space-x-2 items-center">
                <Image src="https://curlified.com/assets/bitmap.dddb5f14.svg" alt="Visa" width={150} height={28} />
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <div className="font-bold text-lg mb-4">{translations["cnct_us"] || "Contact us"}</div>
            <a rel="canonical" href="mailto:contact@curlified.com">contact@curlified.com</a>
            <p className='mt-1 mb-1'>Phone: <a rel="canonical" href="https://wa.me/+971585861464" target="_blank">+971 58 586 1464</a></p>
            <p>Mon - Sat: 10:00 am to 07:00 pm</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

